<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v">For my mam and dad. For bringing me up fed well, safe, and warm, and raising me with love and care. I never fully appreciated how much you did until I became a parent myself.</a></p><a id="page_v">
<p class="ded1">Thank you xxx</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?314fa1ac